import React, { useContext } from 'react';
import { PageProps } from '../components/component-switcher';
import PageGrid from '../components/page-grid';
import SectionTitle from '../components/section-title';
import { generateSectionId } from '../helpers/layout-helpers';
import { FaRegHandPointer } from 'react-icons/fa';
import { HiSelector } from 'react-icons/hi';
import { LangContext } from '../contexts/Lang';

const StandardPage = (props: PageProps) => {
  //   scrollToPageBody()
  let className = `page-container standard-section ${props.type.toLowerCase()}`;
  let Component = props.component;
  if (props.sideMenuTitle) {
    className += ' can-scroll-to';
  }

  const { globalPageData } = useContext(LangContext);

  return (
    <section className={className} id={generateSectionId(props)}>
      <SectionTitle title={props.mainTitle} />
      {props.pageDescription && (
        <div
          className='text-content'
          dangerouslySetInnerHTML={{
            __html: props.pageDescription,
          }}
        />
      )}
      {props.type === 'ColorPaletteArchive' && (
        <>
          <div className='section-type'>
            <div className='section-type__box'>
              <div className='section-type_box-icons'>
                <i className='section-type_box-icon'>
                  <i className='section-type_box-icon_inner'></i>
                </i>
                <FaRegHandPointer
                  size='2.5rem'
                  className='section-type_pointer-icon'
                />
              </div>
              <h4>
                {globalPageData.trykkPaFargenForAKopiereFargekoden ||
                  'Trykk på fargen for å kopiere fargekoden'}
              </h4>
            </div>
            <div className='section-type__box'>
              <div className='section-type_box-icons'>
                <HiSelector size='2.5rem' />
              </div>
              <h4>
                {globalPageData.trykkPaPileneForAEndreFargekode ||
                  'Trykk på pilene for å endre fargekode'}
              </h4>
            </div>
          </div>
        </>
      )}
      <PageGrid columns={props.columns}>
        {props.itemChildren?.map(
          (props) => Component && <Component {...props} />
        )}
      </PageGrid>
    </section>
  );
};

export default StandardPage;
